import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { CustomerPortalAppSettings } from "../settings";

function getFeatureFlagOverride(
  featureFlag: FeatureFlagKey,
): boolean | undefined {
  try {
    const override = localStorage?.getItem(`override-${featureFlag}`);
    if (!override || (override !== "false" && override !== "true")) {
      return undefined;
    }
    return override === "true";
  } catch (error) {
    return undefined;
  }
}

export function getReturnFlowABTestValues(
  settings: CustomerPortalAppSettings | undefined,
  featureFlags: Record<FeatureFlagKey, boolean> | undefined | null,
) {
  if (settings?.exchangeAgentSettings.forceNewFlow) {
    return { useNewExchangeFlow: true };
  }

  const useNewExchangeFlow =
    getFeatureFlagOverride(FeatureFlagKey.NEW_EXCHANGE_REFUND_FLOW) ??
    !!featureFlags?.[FeatureFlagKey.NEW_EXCHANGE_REFUND_FLOW];

  return { useNewExchangeFlow };
}
